export const ACCOUNT_ROLE = {
  MAIN: "MAIN",
  SUB: "SUB",
};
